export default __webpack_public_path__ + "static/media/demo-3.5b1a5c64.png";